import React from "react";
import _ from "lodash";
import "./table.css";

const Table = (props) => {
  const { tableHeadings, tableData } = props;
  return (
    <div>
      <div className="table-heading">{tableHeadings[0].heading}</div>
      <table className="table ">
        <thead>
          <tr>
            {tableHeadings[1].columns.map((column) => (
              <th key={column}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((detail, index) => (
            <tr key={index}>
              {tableHeadings[1].columns.map((column, index) => (
                <td key={index}>{_.get(detail, column)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
